import PublishAffiliatedPanel from "./PublishAffiliatedPanel.vue";
import PublishButton from "./PublishButton.vue";
import PublishCategoryPicker from "./PublishCategoryPicker.vue";
import PublishField from "./PublishField.vue";
import PublishFormCard from "./PublishFormCard.vue";
import PublishRepeatList from "./PublishRepeatList.vue";
import PublishTitle from "./PublishTitle.vue";
import PublishUploadField from "./PublishUploadField.vue";

const components = [
  PublishAffiliatedPanel,
  PublishButton,
  PublishCategoryPicker,
  PublishField,
  PublishFormCard,
  PublishRepeatList,
  PublishTitle,
  PublishUploadField,
];

export {
  PublishAffiliatedPanel,
  PublishButton,
  PublishCategoryPicker,
  PublishField,
  PublishFormCard,
  PublishRepeatList,
  PublishTitle,
  PublishUploadField,
};

export default {
  install(Vue) {
    components.forEach((component) => {
      Vue.component(component.name, component);
    });
  },
};
